import Player from './player.js'
import Bridge from './iframe-bridge-child.js'

let toExport

if (window.location != window.parent.location) {
    toExport = new Bridge()
} else {
    toExport = new Player()
}

window.reactPlayer = toExport
export default toExport


// WEBPACK FOOTER //
// ./js/player-wrapper.js